import React, { useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { StoryModel } from 'types/story';
import { IframeTunnel, IFRAME_ACTIONS } from 'common/utils/iframe-tunnel';
import Story from 'client/components/pages/Story';

const Preview: React.FC<RouteComponentProps> = props => {
	const [story, setStory] = useState<StoryModel | null>(null);
	const IT = useRef(
		new IframeTunnel({
			id: 'Preview',
			messageReceiver: event => setStory(event.data.payload as StoryModel),
			filter: [IFRAME_ACTIONS.GET_STORY],
		})
	);

	useEffect(() => {
		const _IT = IT.current;
		_IT.init();
		_IT.messageTransmitter({
			target: IframeTunnel.targets.admin,
			action: IFRAME_ACTIONS.GET_STORY,
		});
		return () => {
			_IT.destroy();
		};
	}, []);

	if (!story) return null;

	return story && <Story {...props} story={story} />;
};

export default Preview;
